import {
  GET_MESSAGING_CONVERSATION_LIST,
  GET_MESSAGING_CONVERSATION_LIST_SUCCESS,
  GET_MESSAGING_CONVERSATION_LIST_FAILURE,
  SEARCH_MESSAGING_CONVERSATION_MESSAGE_LIST,
  SEARCH_MESSAGING_CONVERSATION_MESSAGE_LIST_SUCCESS,
  SEARCH_MESSAGING_CONVERSATION_MESSAGE_LIST_FAILURE,
  SEND_MESSAGING_CONVERSATION_MESSAGE,
  SEND_MESSAGING_CONVERSATION_MESSAGE_SUCCESS,
  SEND_MESSAGING_CONVERSATION_MESSAGE_FAILURE,
  UPDATE_MESSAGING_CONVERSATION,
  UPDATE_MESSAGING_CONVERSATION_SUCCESS,
  UPDATE_MESSAGING_CONVERSATION_FAILURE,
  CREATE_MESSAGING_CONVERSATION,
  CREATE_MESSAGING_CONVERSATION_SUCCESS,
  CREATE_MESSAGING_CONVERSATION_FAILURE,
  GET_MESSAGING_CHANNEL_LIST,
  GET_MESSAGING_CHANNEL_LIST_SUCCESS,
  GET_MESSAGING_CHANNEL_LIST_FAILURE,
  START_MESSAGING_CONVERSATION_MESSAGE,
  START_MESSAGING_CONVERSATION_MESSAGE_SUCCESS,
  START_MESSAGING_CONVERSATION_MESSAGE_FAILURE,
  SEARCH_MESSAGING_CONVERSATION_TEMPLATE,
  SEARCH_MESSAGING_CONVERSATION_TEMPLATE_SUCCESS,
  SEARCH_MESSAGING_CONVERSATION_TEMPLATE_FAILURE,
  REMOVE_MESSAGING_CONVERSATION_PARTICIPANT,
  REMOVE_MESSAGING_CONVERSATION_PARTICIPANT_SUCCESS,
  REMOVE_MESSAGING_CONVERSATION_PARTICIPANT_FAILURE,
  MARK_MESSAGING_CONVERSATION_READ,
  MARK_MESSAGING_CONVERSATION_READ_SUCCESS,
  MARK_MESSAGING_CONVERSATION_READ_FAILURE,
  MARK_MESSAGING_CONVERSATION_UNREAD,
  MARK_MESSAGING_CONVERSATION_UNREAD_SUCCESS,
  MARK_MESSAGING_CONVERSATION_UNREAD_FAILURE,
  MARK_MESSAGING_CONVERSATION_MESSAGE_READ,
  MARK_MESSAGING_CONVERSATION_MESSAGE_READ_SUCCESS,
  MARK_MESSAGING_CONVERSATION_MESSAGE_READ_FAILURE,
  MARK_MESSAGING_CONVERSATION_MESSAGE_UNREAD,
  MARK_MESSAGING_CONVERSATION_MESSAGE_UNREAD_SUCCESS,
  MARK_MESSAGING_CONVERSATION_MESSAGE_UNREAD_FAILURE,
  GET_MESSAGING_CONVERSATION_DATA,
  GET_MESSAGING_CONVERSATION_DATA_SUCCESS,
  GET_MESSAGING_CONVERSATION_DATA_FAILURE,
  SET_SELECTED_MESSAGING_CONVERSATION,
  SET_SELECTED_MESSAGING_CONVERSATION_SUCCESS,
  SET_SELECTED_MESSAGING_CONVERSATION_FAILURE,
  CLOSE_MESSAGING_CONVERSATION,
  CLOSE_MESSAGING_CONVERSATION_SUCCESS,
  CLOSE_MESSAGING_CONVERSATION_FAILURE,
} from "./actionType";

const initialData = {
  //GET_MESSAGING_CONVERSATION_LIST
  conversationList: [],
  conversationListLoading: false,

  //GET_MESSAGING_CONVERSATION_MESSAGE_LIST
  conversationMessageList: [],
  conversationMessageListLoading: false,

  //SEND_MESSAGING_CONVERSATION_MESSAGE
  sendConversationMessage: [],
  sendConversationMessageLoading: false,

  //UPDATE_MESSAGING_CONVERSATION
  updateConversation: [],
  updateConversationLoading: false,

  //CREATE_MESSAGING_CONVERSATION
  createConversation: [],
  createConversationLoading: false,
  createConversationError: null,
  //GET_MESSAGING_CHANNEL_LIST
  channelList: [],
  channelListLoading: false,
  channelListError: null,
  //START_MESSAGING_CONVERSATION_MESSAGE
  startConversationMessage: [],
  startConversationMessageLoading: false,
  startConversationMessageError: null,
  //SEARCH_MESSAGING_CONVERSATION_TEMPLATE
  conversationTemplate: [],
  conversationTemplateLoading: false,
  conversationTemplateError: null,
  //REMOVE_MESSAGING_CONVERSATION_PARTICIPANT
  removeConversationParticipant: [],
  removeConversationParticipantLoading: false,
  removeConversationParticipantError: null,
  //MARK_MESSAGING_CONVERSATION_READ
  markConversationRead: [],
  markConversationReadLoading: false,
  markConversationReadError: null,
  //MARK_MESSAGING_CONVERSATION_UNREAD
  markConversationUnread: [],
  markConversationUnreadLoading: false,
  markConversationUnreadError: null,
  //MARK_MESSAGING_CONVERSATION_MESSAGE_READ
  markConversationMessageRead: [],
  markConversationMessageReadLoading: false,
  markConversationMessageReadError: null,
  //MARK_MESSAGING_CONVERSATION_MESSAGE_UNREAD
  markConversationMessageUnread: [],
  markConversationMessageUnreadLoading: false,
  markConversationMessageUnreadError: null,
  //GET_MESSAGING_CONVERSATION_DATA
  conversationData: [],
  conversationDataLoading: false,
  conversationDataError: null,
  //SET_SELECTED_MESSAGING_CONVERSATION
  selectedConversation: null,
  selectedConversationLoading: false,
  selectedConversationError: null,
  //CLOSE_MESSAGING_CONVERSATION
  closeConversation: null,
  closeConversationLoading: false,
  closeConversationError: null,
};

const MessagingServiceReducer = (state = initialData, action) => {
  switch (action.type) {
    case GET_MESSAGING_CONVERSATION_LIST:
      return {
        ...state,
        conversationListLoading: true,
      };
    case GET_MESSAGING_CONVERSATION_LIST_SUCCESS:
      return {
        ...state,
        conversationList: action.payload,
        conversationListLoading: false,
      };
    case GET_MESSAGING_CONVERSATION_LIST_FAILURE:
      return {
        ...state,
        conversationListLoading: false,
      };
    case SEARCH_MESSAGING_CONVERSATION_MESSAGE_LIST:
      return {
        ...state,
        conversationMessageListLoading: true,
      };
    case SEARCH_MESSAGING_CONVERSATION_MESSAGE_LIST_SUCCESS:
      return {
        ...state,
        conversationMessageList: action.payload,
        conversationMessageListLoading: false,
      };
    case SEARCH_MESSAGING_CONVERSATION_MESSAGE_LIST_FAILURE:
      return {
        ...state,
        conversationMessageListLoading: false,
      };
    case SEND_MESSAGING_CONVERSATION_MESSAGE:
      return {
        ...state,
        sendConversationMessageLoading: true,
      };
    case SEND_MESSAGING_CONVERSATION_MESSAGE_SUCCESS:
      return {
        ...state,
        sendConversationMessage: action.payload,
        sendConversationMessageLoading: false,
      };
    case SEND_MESSAGING_CONVERSATION_MESSAGE_FAILURE:
      return {
        ...state,
        sendConversationMessageLoading: false,
      };
    case UPDATE_MESSAGING_CONVERSATION:
      return {
        ...state,
        updateConversationLoading: true,
      };
    case UPDATE_MESSAGING_CONVERSATION_SUCCESS:
      return {
        ...state,
        updateConversation: action.payload,
        updateConversationLoading: false,
      };
    case UPDATE_MESSAGING_CONVERSATION_FAILURE:
      return {
        ...state,
        updateConversationLoading: false,
      };
    case CREATE_MESSAGING_CONVERSATION:
      return {
        ...state,
        createConversationLoading: true,
      };
    case CREATE_MESSAGING_CONVERSATION_SUCCESS:
      return {
        ...state,
        createConversation: action.payload,
        createConversationLoading: false,
      };
    case CREATE_MESSAGING_CONVERSATION_FAILURE:
      return {
        ...state,
        createConversationLoading: false,
        createConversationError: action.payload,
      };
    case GET_MESSAGING_CHANNEL_LIST:
      return {
        ...state,
        channelListLoading: true,
      };
    case GET_MESSAGING_CHANNEL_LIST_SUCCESS:
      return {
        ...state,
        channelList: action.payload,
        channelListLoading: false,
      };
    case GET_MESSAGING_CHANNEL_LIST_FAILURE:
      return {
        ...state,
        channelListLoading: false,
        channelListError: action.payload,
      };
    case START_MESSAGING_CONVERSATION_MESSAGE:
      return {
        ...state,
        startConversationMessageLoading: true,
      };
    case START_MESSAGING_CONVERSATION_MESSAGE_SUCCESS:
      return {
        ...state,
        startConversationMessage: action.payload,
        startConversationMessageLoading: false,
      };
    case START_MESSAGING_CONVERSATION_MESSAGE_FAILURE:
      return {
        ...state,
        startConversationMessageLoading: false,
        startConversationMessageError: action.payload,
      };
    case SEARCH_MESSAGING_CONVERSATION_TEMPLATE:
      return {
        ...state,
        conversationTemplateLoading: true,
      };
    case SEARCH_MESSAGING_CONVERSATION_TEMPLATE_SUCCESS:
      return {
        ...state,
        conversationTemplate: action.payload,
        conversationTemplateLoading: false,
      };
    case SEARCH_MESSAGING_CONVERSATION_TEMPLATE_FAILURE:
      return {
        ...state,
        conversationTemplateLoading: false,
        conversationTemplateError: action.payload,
      };
    case REMOVE_MESSAGING_CONVERSATION_PARTICIPANT:
      return {
        ...state,
        removeConversationParticipantLoading: true,
      };
    case REMOVE_MESSAGING_CONVERSATION_PARTICIPANT_SUCCESS:
      return {
        ...state,
        removeConversationParticipant: action.payload,
        removeConversationParticipantLoading: false,
      };
    case REMOVE_MESSAGING_CONVERSATION_PARTICIPANT_FAILURE:
      return {
        ...state,
        removeConversationParticipantLoading: false,
        removeConversationParticipantError: action.payload,
      };
    case MARK_MESSAGING_CONVERSATION_READ:
      return {
        ...state,
        markConversationReadLoading: true,
      };
    case MARK_MESSAGING_CONVERSATION_READ_SUCCESS:
      return {
        ...state,
        markConversationRead: action.payload,
        markConversationReadLoading: false,
      };
    case MARK_MESSAGING_CONVERSATION_READ_FAILURE:
      return {
        ...state,
        markConversationReadLoading: false,
        markConversationReadError: action.payload,
      };
    case MARK_MESSAGING_CONVERSATION_UNREAD:
      return {
        ...state,
        markConversationUnreadLoading: true,
      };
    case MARK_MESSAGING_CONVERSATION_UNREAD_SUCCESS:
      return {
        ...state,
        markConversationUnread: action.payload,
        markConversationUnreadLoading: false,
      };
    case MARK_MESSAGING_CONVERSATION_UNREAD_FAILURE:
      return {
        ...state,
        markConversationUnreadLoading: false,
        markConversationUnreadError: action.payload,
      };
    case MARK_MESSAGING_CONVERSATION_MESSAGE_READ:
      return {
        ...state,
        markConversationMessageReadLoading: true,
      };
    case MARK_MESSAGING_CONVERSATION_MESSAGE_READ_SUCCESS:
      return {
        ...state,
        markConversationMessageRead: action.payload,
        markConversationMessageReadLoading: false,
      };
    case MARK_MESSAGING_CONVERSATION_MESSAGE_READ_FAILURE:
      return {
        ...state,
        markConversationMessageReadLoading: false,
        markConversationMessageReadError: action.payload,
      };
    case MARK_MESSAGING_CONVERSATION_MESSAGE_UNREAD:
      return {
        ...state,
        markConversationMessageUnreadLoading: true,
      };
    case MARK_MESSAGING_CONVERSATION_MESSAGE_UNREAD_SUCCESS:
      return {
        ...state,
        markConversationMessageUnread: action.payload,
        markConversationMessageUnreadLoading: false,
      };
    case MARK_MESSAGING_CONVERSATION_MESSAGE_UNREAD_FAILURE:
      return {
        ...state,
        markConversationMessageUnreadLoading: false,
        markConversationMessageUnreadError: action.payload,
      };
    case GET_MESSAGING_CONVERSATION_DATA:
      return {
        ...state,
        conversationDataLoading: true,
      };
    case GET_MESSAGING_CONVERSATION_DATA_SUCCESS:
      return {
        ...state,
        conversationData: action.payload,
        conversationDataLoading: false,
      };
    case GET_MESSAGING_CONVERSATION_DATA_FAILURE:
      return {
        ...state,
        conversationDataLoading: false,
        conversationDataError: action.payload,
      };
    case SET_SELECTED_MESSAGING_CONVERSATION:
      return {
        ...state,
        selectedConversationLoading: true,
      };
    case SET_SELECTED_MESSAGING_CONVERSATION_SUCCESS:
      return {
        ...state,
        selectedConversation: action.payload,
        selectedConversationLoading: false,
      };
    case SET_SELECTED_MESSAGING_CONVERSATION_FAILURE:
      return {
        ...state,
        selectedConversationLoading: false,
        selectedConversationError: action.payload,
      };
    case CLOSE_MESSAGING_CONVERSATION:
      return {
        ...state,
        closeConversationLoading: true,
      };
    case CLOSE_MESSAGING_CONVERSATION_SUCCESS:
      return {
        ...state,
        closeConversation: action.payload,
        closeConversationLoading: false,
      };
    case CLOSE_MESSAGING_CONVERSATION_FAILURE:
      return {
        ...state,
        closeConversationLoading: false,
        closeConversationError: action.payload,
      };
    default:
      return state;
  }
};

export default MessagingServiceReducer;
